export default __webpack_public_path__ + "static/media/MnftOver.614d0039.png";